/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import {Link} from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import {Toaster} from "react-hot-toast";
import RateContext from "../../Context/RateContext";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import AddSetting from "../../Components/Settings/PocketMoneySettings/AddSetting";
import PocketMoneySettingsTable from "../../Components/Common/Settings/PocketMoneySettings/PocketMoneySettingsTable";
import EnableTransactions from "../../Components/Settings/PocketMoneySettings/EnableTransactions";
import DisableTransactions from "../../Components/Settings/PocketMoneySettings/DisableTransactions";

function PocketMoneySettingsPage() {

    const {globalPocketMoneySettings, getGlobalPocketMoneySettings, vendorPocketMoneySettings, getVendorPocketMoneySettings, schoolPocketMoneySettings, getSchoolPocketMoneySettings, loading} = useContext(RateContext);

    const refreshData = () =>{
        getGlobalPocketMoneySettings();
        getSchoolPocketMoneySettings();
        getVendorPocketMoneySettings();
    }

    useEffect(() => {
        getGlobalPocketMoneySettings();
        getSchoolPocketMoneySettings();
        getVendorPocketMoneySettings();
    }, []);

    const [modal, setModal] = useStateCallback(false);

    const handleEnable=(e,item)=>{
        setModal(false, ()=>setModal(<EnableTransactions settingID={item.setting_id} g={getGlobalPocketMoneySettings} h={getSchoolPocketMoneySettings} i={getVendorPocketMoneySettings} isOpen={true}/>))
    }

    const handleDisable=(e,item)=>{
        setModal(false, ()=>setModal(<DisableTransactions settingID={item.setting_id} g={getGlobalPocketMoneySettings} h={getSchoolPocketMoneySettings} i={getVendorPocketMoneySettings} isOpen={true}/>))
    }


    return (
        <AppContainer title="Pocket Money Settings">
            <Toaster position="top-center" reverseOrder={false} />
            {modal}
            <div className="row">
                

                <div className="col-lg-4">
                    <AddSetting g={getGlobalPocketMoneySettings} h={getSchoolPocketMoneySettings} i={getVendorPocketMoneySettings}/>
                </div>

                <div className="col-lg-8">
                    <div className="card custom-card" style={{borderRadius: "10px"}}>
                        <div className="card-body map-card">
                            <div class="heading-layout1 mg-b-25">
                                <TableHeader
                                title="Pocket Money Settings"
                                subtitle="List of all the pocket money settings"
                                />
                                <div class="dropdown">
                                <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                                </div>
                                </div>
                            </div>
                                        
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                <Col sm={12}>
                                <Nav variant="pills" className="flex-row mb-1">
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="first">
                                        Global Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="second">
                                    School Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="third">
                                    Vendor Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                </Nav>
                            </Col>

                            <Col sm={12}>
                                <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                            <Loader /> 
                                        ) : (
                                        <PocketMoneySettingsTable settingList={globalPocketMoneySettings} handleEnable={handleEnable}  handleDisable={handleDisable} scopeType="global"/>
                                        )}
                            
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="second">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <PocketMoneySettingsTable settingList={schoolPocketMoneySettings} handleEnable={handleEnable} handleDisable={handleDisable} scopeType="school"/>
                                        )}
                                    </div>

                                </Tab.Pane>

                                <Tab.Pane eventKey="third">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <PocketMoneySettingsTable settingList={vendorPocketMoneySettings} handleEnable={handleEnable} handleDisable={handleDisable} scopeType="vendor"/>
                                        )}
                                    </div>

                                </Tab.Pane>
                                </Tab.Content>
                            </Col>
                            </Row>
                            </Tab.Container>                
                                                        
                        </div>
                    </div>
                </div>
            </div>
        </AppContainer>
    );
}

export default PocketMoneySettingsPage;
